import { setAuthorization, setUserInfo } from "utils/storage/local";

const signIn = ({ authorization, userInfo }) => {
  setAuthorization(authorization);
  setUserInfo(userInfo);
};
export default signIn;
